import { useLayoutEffect as e } from "react";
//#region src/components/Composer/hooks/useAutoGrow.ts
function t(t, n) {
	e(() => {
		let e = t.current;
		e && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`);
	}, [t, n]);
}
//#endregion
export { t as useAutoGrow };
